import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { AppBar, Toolbar, Typography, IconButton, Box } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import TF from './api/requests/tf_backend'
// Import components and pages
import Sidebar from "./components/Sidebar";
import LoginButton from "./components/LoginButton";
import Home from "./pages/Home";
import About from "./pages/About";
import Holdings from "./pages/Holdings";
import Orders from "./pages/Orders";
import NotFound from "./pages/NotFound";
import PlaceOrder from "./pages/PlaceOrder";
import Alerts from "./pages/Alerts";
import PrimaryAlerts from "./pages/PrimaryAlerts";


const App = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [requestToken, setRequestToken] = useState("");


  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  useEffect(() => {
    const fetchToken = async () => {
      try {
        const params = new URLSearchParams(window.location.search);
        const token = params.get("request_token");
        if (token) {
          console.log(token);
          await TF.addAccessToken(token);
          setRequestToken(token);
        }
      } catch (error) {
        console.error("Failed to fetch token:", error);
      }
    };
  
    fetchToken();
  }, []);
  const isLoggedIn = localStorage.getItem("Token");

  return (
    <GoogleOAuthProvider clientId="463348619586-5pghe0e8kvht262j7iohgqbbn9p8idmo.apps.googleusercontent.com">
      {isLoggedIn ? (
        <Box sx={{ display: "flex" }}>
          {/* AppBar */}
          <AppBar
            position="fixed"
            sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
          >
            <Toolbar>
              <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                onClick={handleDrawerToggle}
                sx={{ display: { sm: "none" } }}
              >
                <MenuIcon />
              </IconButton>
              <Typography variant="h6" noWrap>
                Technofunda
              </Typography>
            </Toolbar>
          </AppBar>

          {/* Sidebar */}
          <Sidebar
            mobileOpen={mobileOpen}
            handleDrawerToggle={handleDrawerToggle}
          />

          {/* Main Content */}
          <Box
            component="main"
            sx={{
              flexGrow: 1,
              p: 3,
              width: { sm: `calc(100% - 240px)` },
              ml: { sm: "240px" },
            }}
          >
            <Toolbar />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/holdings" element={<Holdings />} />
               <Route path="/alerts" element={<PrimaryAlerts />} />
              <Route path="/orders" element={<Orders />} />
              <Route path="/about" element={<About />} />
              <Route path="/info/place_order" element={<PlaceOrder />} />
              <Route path="/info/alerts" element={<Alerts />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Box>
        </Box>
      ) : (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "100vh",
            bgcolor: "#f5f5f5",
          }}
        >
          <Typography variant="h3" gutterBottom>
            Welcome to Technofunda
          </Typography>
          <LoginButton />
        </Box>
      )}
    </GoogleOAuthProvider>
  );
};

export default App;
